<template>
  <div>
    <div v-show="loading" class="flex justify-center mt3">
      <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
    </div>
    <div v-show="!loading" class="overflow-y-scroll total-height">
      <div class="mt3-l ml5-l mr5-l">
        <p v-show="!hasArtists" class="f3-ns tc textColor">{{ $t('vinylContest.noArtist') }}</p>

        <p v-show="info" class="f3-ns tc textColor">{{ $t('vinylContest.closeIn') }}
          <countdown :end="info.final"></countdown>
        </p>

        <div v-if="index < 4"
             v-for="(artist, index) in artists"
             :track-by="artist.id"
             :key="artist.id">
          <vinyl-contest-podium class="mr2" :artist="artist" :index="index"/>
        </div>

        <div class="flex flex-column">
          <div class="bb b--black-05 pa1"
               v-if="index >= 4"
               v-for="(artist, index) in artists"
               :track-by="artist.id"
               :key="artist.id">
            <div class="flex items-center justify-between">
              <div class="flex justify-start items-center">
                <div class="image-container-list flex items-center justify-center">
                  <img v-show="artist" class="h-100" :src="picture(artist)">
                </div>
                <div class="flex items-center number mr2 ml2">
                  <span class="light-silver f2-l f5">#</span><span class="light-silver f1-l f3">{{index + 1}}</span>
                </div>
                <router-link :to="{ name:'artist-info', params: { id: artist.id }}" class="textColor no-underline">
                  <div class="artist-info">
                    <artist-data :artist="artist" :isPodium="index > 0 && index < 4"></artist-data>
                  </div>
                </router-link>
              </div>
              <div class="db-ns dn pr4-l pr2">
                <circle-progress :percent="artist.percent" emptyFill="#aaa"
                                 :fill="{gradient: ['rgba(0, 0, 0, .8)', 'gray', 'darkgray']}"
                                 class="mr2-l"></circle-progress>
              </div>
              <div class="dn-ns pr2">
                <circle-progress :percent="artist.percent" emptyFill="#aaa"
                                 :fill="{gradient: ['rgba(0, 0, 0, .8)', 'gray', 'darkgray']}"
                                 :size="60"></circle-progress>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ArtistData from '@/components/charts/ArtistData'
  import CircleProgress from '@/components/charts/CircleProgress'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import consts from '@/consts'
  import Countdown from './Countdown.vue'
  import VinylContestPodium from './VinylContestPodium.vue'

  export default {
    data () {
      return {
        artists: [],
        info: [],
        loading: true,
        hasArtists: false,
        color: '#808080',
        size: '30px'
      }
    },
    components: {
      Countdown,
      ArtistData,
      CircleProgress,
      ClipLoader,
      VinylContestPodium
    },
    created () {
      this.getArtists()
        .then(response => {
          if (response.body.data['cant'] > 0) {
            this.artists = response.body.data.data
            this.info = response.body.data
            this.loading = false
            this.hasArtists = true
          } else {
            this.hasArtists = false
          }
        })
    },
    methods: {
      getArtists (from) {
        return this.$http.get(consts.API_BASE_URL + '/tracks/getContest')
      },
      picture (artist) {
        return consts.MEDIA_BASE_URL + artist.path + artist.picture
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .total-height {
    height: $main-height;
    width: 100%;
  }

  .image-container-list {
    height: 90px;
    width: 90px;
    min-width: 90px;
  }

  .artist-info {
    max-width: 50vw;
  }

  .number {
    width: 5rem;
    min-width: 5rem;
  }

  @media (min-width: 1441px) {
    .artist-list {
      padding-left: 20rem;
      padding-right: 20rem;
    }
  }

  @media screen and (min-width: 1024px) {
    .artist-info {
      max-width: 55vw;
    }
  }

  @media (max-width: 959px) {
    .number {
      width: 2rem;
      min-width: 2rem;
    }
  }

  @media screen and (max-width: 768px) {
    .artist-info {
      max-width: 50vw;
    }
  }

  @media screen and (max-width: 479px) {
    .image-container-list {
      height: 50px;
      width: 50px;
      min-width: 50px;
    }

    .artist-info {
      max-width: 45vw;
    }
  }

  @media screen and (max-width: 320px) {
    .artist-info {
      max-width: 40vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/charts/VinylContest.vue